import React, { useEffect, useState, createContext, useContext } from 'react';
import { translations } from './translations';
type Language = 'es' | 'en';
interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: typeof translations.es;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLang] = useState<Language>('es');
  useEffect(() => {
    const savedLang = localStorage.getItem('riam_lang') as Language;
    if (savedLang && (savedLang === 'es' || savedLang === 'en')) {
      setLang(savedLang);
    }
  }, []);
  const handleSetLang = (newLang: Language) => {
    setLang(newLang);
    localStorage.setItem('riam_lang', newLang);
  };
  return <LanguageContext.Provider value={{
    lang,
    setLang: handleSetLang,
    t: translations[lang]
  }} data-id="element-390">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}